import * as React from 'react';

export function IX3GsapScrollMarkerStyle() {
  return <style>{MARKERS_CSS}</style>;
}

const MARKERS_CSS = `
.gsap-marker-end,
.gsap-marker-scroller-end,
.gsap-marker-scroller-start,
.gsap-marker-start {
  color: transparent !important;
  font-size: 11.5px !important;
  letter-spacing: -.115px !important;
  padding: 0 !important;
  height: 16px !important;
  border: none !important
}

.gsap-marker-end,
.gsap-marker-start {
  border-top-left-radius: 3px !important;
  border-bottom-left-radius: 3px !important
}

.gsap-marker-scroller-end,
.gsap-marker-scroller-start {
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 3px !important
}

.gsap-marker-scroller-start,
.gsap-marker-start {
  background-color: #259d4d !important
}

.gsap-marker-end,
.gsap-marker-scroller-end {
  background-color: #e42f3a !important
}

.gsap-marker-scroller-start {
  width: 80px !important;
  right: 145px !important
}

.gsap-marker-scroller-end {
  width: 73px !important
}

.gsap-marker-start {
  width: 34px !important;
  left: auto !important;
  right: 244px !important
}

.gsap-marker-end {
  width: 29px !important;
  left: auto !important;
  right: 100px !important
}

.gsap-marker-scroller-end {
  left: auto !important;
  right: 8px !important
}

.gsap-marker-end:before {
  content: "End"
}
.gsap-marker-start:before {
  content: "Start"
}
.gsap-marker-scroller-end:before {
  content: "Scroller end"
}
.gsap-marker-scroller-start:before {
  content: "Scroller start"
}

.gsap-marker-end:nth-child(5):before {
  content: "End 2"
}
.gsap-marker-end:nth-child(9):before {
  content: "End 3"
}
.gsap-marker-end:nth-child(13):before {
  content: "End 4"
}
.gsap-marker-end:nth-child(17):before {
  content: "End 5"
}


.gsap-marker-start:nth-child(6):before {
  content: "Start 2"
}
.gsap-marker-start:nth-child(10):before {
  content: "Start 3"
}
.gsap-marker-start:nth-child(14):before {
  content: "Start 4"
}
.gsap-marker-start:nth-child(18):before {
  content: "Start 5"
}

.gsap-marker-scroller-start:nth-child(8):before {
  content: "Scroller start 2"
}
.gsap-marker-scroller-start:nth-child(12):before {
  content: "Scroller start 3"
}
.gsap-marker-scroller-start:nth-child(16):before {
  content: "Scroller start 4"
}
.gsap-marker-scroller-start:nth-child(20):before {
  content: "Scroller start 5"
}

.gsap-marker-scroller-end:nth-child(7):before {
  content: "Scroller end 2"
}
.gsap-marker-scroller-end:nth-child(11):before {
  content: "Scroller end 3"
}
.gsap-marker-scroller-end:nth-child(15):before {
  content: "Scroller end 4"
}
.gsap-marker-scroller-end:nth-child(19):before {
  content: "Scroller end 5"
}

/* n2+ markers get slightly wider widths */
.gsap-marker-end:nth-child(n+5) {
    width: 40px !important;
    right: 114px !important;
}
.gsap-marker-start:nth-child(n+5) {
    width: 45px !important;
    right: 255px !important;
}
.gsap-marker-scroller-end:nth-child(n+5) {
    width: 85px !important;
}
.gsap-marker-scroller-start:nth-child(n+5) {
    width: 89px !important;
}

.gsap-marker-end:after,
.gsap-marker-scroller-end:after,
.gsap-marker-scroller-start:after,
.gsap-marker-start:after {
  width: 0;
  height: 0;
  top: 0;
  position: absolute;
  border-style: solid;
  content: ''
}

.gsap-marker-end:after,
.gsap-marker-start:after {
  border-width: 0 10px 16px 0;
  right: -10px
}

.gsap-marker-scroller-end:after,
.gsap-marker-scroller-start:after {
  border-width: 0 10px 16px 0;
  transform: rotate(180deg);
  left: -10px
}

.gsap-marker-scroller-start:after,
.gsap-marker-start:after {
  border-color: transparent transparent #259d4d
}

.gsap-marker-end:after,
.gsap-marker-scroller-end:after {
  border-color: transparent transparent #e42f3a
}

.gsap-marker-end:before,
.gsap-marker-scroller-end:before,
.gsap-marker-scroller-start:before,
.gsap-marker-start:before {
  color: #fff !important;
  position: absolute !important;
  top: 2px !important;
  font-weight: 400 !important;
  line-height: 1 !important;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto !important
}

.gsap-marker-end:before,
.gsap-marker-start:before {
  left: 5px !important
}

.gsap-marker-scroller-end:before,
.gsap-marker-scroller-start:before {
  left: auto !important;
  right: 6px !important
}
`;
